import React from 'react';
import { SIZE_SMALL } from 'eventbrite_design_system/button/constants';
import CheckChunkySvg from 'eventbrite_design_system/iconography/icons/CheckChunky';
import Icon from 'eventbrite_design_system/icon/Icon';

const CheckMark = ({ size, strokeColor }) => (
    <Icon type={<CheckChunkySvg />} size={size} strokeColor={strokeColor} />
);

CheckMark.defaultProps = {
    size: SIZE_SMALL,
    strokeColor: 'ui-orange',
};

export default CheckMark;
